import { Paper } from "@mui/material";
import { darken } from "@mui/material/styles";
import type { GridColDef } from "@mui/x-data-grid-premium";
import DataGrid from "@entrilia/shared/components/grid/DataGrid";
import type { WorkflowActivityChangeSetRow } from "./workflowActivityChangeSetGridProvider";

interface Props {
  columns: GridColDef<WorkflowActivityChangeSetRow>[];
  rows: WorkflowActivityChangeSetRow[];
}

const getRowClassName = ({ row }: { row: WorkflowActivityChangeSetRow }) => {
  const classNames = [];

  if (row.isSelected) {
    classNames.push("selected-change-set-row");
  }

  if (row.attributes?.includes("Calculated")) {
    classNames.push("calculated-change-set-row");
  }

  return classNames.join(" ");
};

const WorkflowActivityChangeSetGrid = ({ columns, rows }: Props) => {
  return (
    <Paper variant="outlined" sx={{ py: 0.25 }}>
      <DataGrid<WorkflowActivityChangeSetRow>
        columns={columns}
        rows={rows}
        disableColumnReorder
        disableColumnSorting
        noScrollableContainer
        getRowClassName={getRowClassName}
        sx={(t) => ({
          "& .MuiDataGrid-row": {
            "&.selected-change-set-row": {
              border: `1px solid ${t.palette.primary.main}`,
              borderRadius: t.spacing(1),
            },
            "&.calculated-change-set-row": {
              backgroundColor: darken(t.palette.background.grey, 0.05),
            },
          },
        })}
      />
    </Paper>
  );
};

export default WorkflowActivityChangeSetGrid;
